// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"931":"ea0f7027","973":"aef68c2f"}[chunkId] + ".css";
};